import _ from 'lodash';
import { formatISO, startOfDay, parseISO } from 'date-fns';
import { orderCommitted } from './getToBePaid';
const getCommittedTransactions = (data, includeInternal = false) => {
    let arrayToBePaid = [];
    let arrayPaid = [];
    let totalToBePaid = 0;
    let totalPaid = 0;
    let totalIncomeToBeReceived = 0;
    let totalIncomeReceived = 0;
    if (data) {
        const modifiedArrayToBePaid = [];
        const modifiedArrayPaid = [];
        for (let index = 0; index < data.length; index++) {
            const includeInTotals = !data[index].isInternal || includeInternal;
            const { isIncome } = data[index];
            for (let x = 0; x < data[index].predictions.length; x++) {
                if (includeInTotals) {
                    if (isIncome)
                        totalIncomeToBeReceived += data[index].convertedPrice.amount;
                    else
                        totalToBePaid += data[index].convertedPrice.amount;
                }
                modifiedArrayToBePaid.push({
                    ...data[index],
                    prediction: data[index].predictions[x],
                });
            }
            for (let x = 0; x < data[index].transactions.length; x++) {
                if (includeInTotals) {
                    // Signed netting: a refund credit on a spending subscription
                    // reduces the paid total instead of inflating it.
                    const { amount } = data[index].transactions[x];
                    if (isIncome)
                        totalIncomeReceived += amount;
                    else
                        totalPaid += -amount;
                }
                modifiedArrayPaid.push({
                    ...data[index].transactions[x],
                    subscription: data[index],
                });
            }
        }
        const orderedToBePaid = orderCommitted(modifiedArrayToBePaid);
        const groupedToBePaid = _.groupBy(orderedToBePaid, (d) => {
            const date = d.prediction?.date ? parseISO(d.prediction.date) : null;
            return date ? formatISO(startOfDay(date)) : 'Invalid Date';
        });
        arrayToBePaid = _.reduce(groupedToBePaid, (acc, next) => {
            acc.push({ data: next });
            return acc;
        }, []);
        const groupedPaid = _.groupBy(modifiedArrayPaid, () => 'Invalid Date');
        arrayPaid = _.reduce(groupedPaid, (acc, next) => {
            acc.push({ data: next });
            return acc;
        }, []);
    }
    return {
        arrayToBePaid,
        arrayPaid,
        totalPaid,
        totalToBePaid,
        totalIncomeReceived,
        totalIncomeToBeReceived,
    };
};
export const getCommittedTransactionsForTrueBalance = (data, includeInternal = false) => {
    let arrayToBePaid = [];
    let arrayPaid = [];
    let totalToBePaid = 0;
    let totalPaid = 0;
    let totalIncomeToBeReceived = 0;
    let totalIncomeReceived = 0;
    if (data) {
        const modifiedArrayToBePaid = [];
        const modifiedArrayPaid = [];
        for (let index = 0; index < data.length; index++) {
            const includeInTotals = !data[index].isInternal || includeInternal;
            const { isIncome } = data[index];
            for (let x = 0; x < data[index].predictions.length; x++) {
                if (includeInTotals) {
                    if (isIncome)
                        totalIncomeToBeReceived += data[index].nativePrice.amount;
                    else
                        totalToBePaid += data[index].nativePrice.amount;
                }
                modifiedArrayToBePaid.push({
                    ...data[index],
                    prediction: data[index].predictions[x],
                });
            }
            for (let x = 0; x < data[index].transactions.length; x++) {
                const { amount: txnAmount, nativeAmount } = data[index].transactions[x];
                // Signed netting: a refund credit on a spending subscription reduces
                // the paid total instead of inflating it.
                const amount = nativeAmount ? nativeAmount.amount : txnAmount;
                if (includeInTotals) {
                    if (isIncome)
                        totalIncomeReceived += amount;
                    else
                        totalPaid += -amount;
                }
                modifiedArrayPaid.push({
                    ...data[index].transactions[x],
                    subscription: data[index],
                });
            }
        }
        const orderedToBePaid = orderCommitted(modifiedArrayToBePaid);
        const groupedToBePaid = _.groupBy(orderedToBePaid, (d) => {
            const date = d.prediction?.date ? parseISO(d.prediction.date) : null;
            return date ? formatISO(startOfDay(date)) : 'Invalid Date';
        });
        arrayToBePaid = _.reduce(groupedToBePaid, (acc, next, index) => {
            acc.push({
                key: index,
                data: next,
            });
            return acc;
        }, []);
        const orderedPaid = orderCommitted(modifiedArrayPaid);
        const groupedPaid = _.groupBy(orderedPaid, (d) => {
            const date = d.prediction?.date ? parseISO(d.prediction.date) : null;
            return date ? formatISO(startOfDay(date)) : 'Invalid Date';
        });
        arrayPaid = _.reduce(groupedPaid, (acc, next, index) => {
            acc.push({
                key: index,
                data: next,
            });
            return acc;
        }, []);
    }
    return {
        arrayToBePaid,
        arrayPaid,
        totalPaid,
        totalToBePaid,
        totalIncomeReceived,
        totalIncomeToBeReceived,
    };
};
export default getCommittedTransactions;
